import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import HeadlessCheck from '../components/headless-check'

import Home from './home'
import Welcome from './welcome'
import Confirm from './confirm'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <HeadlessCheck>
        <Home />
      </HeadlessCheck>
    ),
  },
  {
    path: '/email',
    element: (
      <HeadlessCheck>
        <Welcome />
      </HeadlessCheck>
    ),
  },
  {
    path: '/confirm',
    element: (
      <HeadlessCheck>
        <Confirm />
      </HeadlessCheck>
    ),
  }
])

const Router = () => <RouterProvider router={router} />

export default Router
